import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import NotFoundPage from "./NotFoundPage";
import Layout from './Layout/Layout';
import ProfilePage from "./pages/Profile/ProfilePage";
import AcademicSession from "./pages/AcademicSession/AcademicSession";
import MySubjects from "./pages/Profile/MySubjects";
import Payments from "./pages/Profile/Payments";
import PaymentReturn from "./pages/Profile/PaymentReturn";
import PaymentReceipt from "./pages/Profile/PaymentReceipt";
import Attendance from "./pages/Attendance/Attendance";
import Assignments from "./pages/Assignments/Assignments";
import Library from "./pages/Library/Library";
import Transport from "./pages/Transport/Transport";
import ExamSchedule from "./pages/Exams/ExamSchedule";
import AdmitCard from "./pages/Exams/AdmitCard";
import PrivateRoute from "./Components/PrivateRoute";
import { Toaster } from "react-hot-toast";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("parentToken");
    const studentId = localStorage.getItem("selectedStudentId");
    const student = sessionStorage.getItem("student");
    setIsAuthenticated((!!token && !!studentId) || !!student);
  }, []);

  return (
    <Router>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
        containerStyle={{
          bottom: 80, // Offset it below the Navbar height
        }}
        toastOptions={{
          duration: 3000,
          style: {
            background: '#fff',
            color: '#363636',
          },
        }}
      />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage setAuth={setIsAuthenticated} />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Protected Routes */}
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/academic-sessions" element={<AcademicSession />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payment-return" element={<PaymentReturn />} />
          <Route path="/payment/receipt" element={<PaymentReceipt />} />
          <Route path="/subjects" element={<MySubjects />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/assignments" element={<Assignments />} />
          <Route path="/library" element={<Library />} />
          <Route path="/transport" element={<Transport />} />
          <Route path="/exam-schedule" element={<ExamSchedule />} />
          <Route path="/admit-card" element={<AdmitCard />} />
        </Route>

        {/* 404 Page */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
